// // src/components/layout/Sidebar.jsx
// import React, { useState, useEffect, useContext, useCallback } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import {
//   FaTachometerAlt, FaUsers, FaFileInvoiceDollar,
//   FaMoneyBillWave, FaBars, FaTimes,
//   FaClipboardList, FaUser, FaDesktop, FaWhmcs,
//   FaBell, FaWhatsapp, FaEnvelope, FaChevronDown, FaChevronUp, FaChartBar,
//   FaUserShield, FaShieldAlt, FaChartPie, FaFileAlt, FaTv, FaLock,
//   FaFileContract, FaFileSignature, FaDownload
// } from 'react-icons/fa';
// import '../../responsive.css';
// import logoVermelha from '../../assets/logo-vermelha.png';
// import { AuthContext } from '../../contexts/AuthContext';
// import { useFeatureGate } from '../../hooks/useFeatureGate';
// import { usePWAInstall } from '../../hooks/usePWAInstall';
// import ModalUpgradePlano from '../ModalUpgradePlano';

// const MOBILE_BREAKPOINT = 992;
// const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

// const Sidebar = ({ collapsed, toggleSidebar }) => {
//   const location = useLocation();
//   const { userFirebase, user } = useContext(AuthContext);

//   const {
//     tier,
//     blockedFeature,
//     checkAccess,
//     closeModal,
//     isAllowed,
//   } = useFeatureGate();

//   // 🆕 Hook de instalação do PWA
//   const { canInstall, promptInstall } = usePWAInstall();

//   const [mobileView, setMobileView]             = useState(() => isMobile());
//   const [desktopCollapsed, setDesktopCollapsed] = useState(false);
//   const [notificacoesOpen, setNotificacoesOpen] = useState(false);
//   const [relatoriosOpen,   setRelatoriosOpen]   = useState(false);
//   const [superAdminOpen,   setSuperAdminOpen]   = useState(false);
//   const [contratosOpen,    setContratosOpen]    = useState(false);

//   // ── Acessos centralizados ──
//   const hasRecibosAccess     = isAllowed('boleto');
//   const hasRelatoriosAccess  =
//     isAllowed('relatorios') || isAllowed('relatoriosNotificacao');
//   const hasNotificacoesAccess =
//     isAllowed('whatsapp') || isAllowed('emailNotificacao');

//   const notificacoesRoutes = ['/notificacoes/whatsapp', '/notificacoes/email'];
//   const relatoriosRoutes = [
//     '/relatorios/equipamentos', '/relatorios/veiculacao',
//     '/relatorios/whatsapp', '/relatorios/email', '/relatorios/contratos-expirando'
//   ];
//   const superAdminRoutes = ['/superadmin/empresas', '/superadmin/dashboard'];
//   const contratosRoutes  = ['/contratos', '/contratos/modelos'];

//   const isNotificacoesActive = notificacoesRoutes.includes(location.pathname);
//   const isRelatoriosActive   = relatoriosRoutes.includes(location.pathname);
//   const isSuperActive        = superAdminRoutes.includes(location.pathname);
//   const isContratosActive    = contratosRoutes.includes(location.pathname);

//   useEffect(() => { if (isNotificacoesActive) setNotificacoesOpen(true); }, [isNotificacoesActive]);
//   useEffect(() => { if (isRelatoriosActive)   setRelatoriosOpen(true);   }, [isRelatoriosActive]);
//   useEffect(() => { if (isSuperActive)        setSuperAdminOpen(true);   }, [isSuperActive]);
//   useEffect(() => { if (isContratosActive)    setContratosOpen(true);    }, [isContratosActive]);

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = isMobile();
//       setMobileView(mobile);
//       if (!mobile) setDesktopCollapsed(false);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     if (desktopCollapsed) {
//       setNotificacoesOpen(false);
//       setRelatoriosOpen(false);
//       setSuperAdminOpen(false);
//       setContratosOpen(false);
//     }
//   }, [desktopCollapsed]);

//   const handleLinkClick = useCallback(() => {
//     if (mobileView) toggleSidebar();
//   }, [mobileView, toggleSidebar]);

//   const handleToggle = () => {
//     if (mobileView) toggleSidebar();
//     else setDesktopCollapsed(prev => !prev);
//   };

//   const sidebarClass = [
//     'sidebar',
//     !mobileView && desktopCollapsed ? 'collapsed' : '',
//     mobileView && !collapsed ? 'show' : '',
//   ].filter(Boolean).join(' ');

//   const menuItems = [
//     { path: '/dashboard',    icon: <FaTachometerAlt />,     text: 'Dashboard'    },
//     { path: '/clientes',     icon: <FaUsers />,             text: 'Clientes'     },
//     { path: '/equipamentos', icon: <FaDesktop />,           text: 'Equipamentos' },
//     { path: '/planos',       icon: <FaClipboardList />,     text: 'Planos'       },
//     { path: '/pedidos',      icon: <FaFileInvoiceDollar />, text: 'Pedidos'      },
//     { path: '/contas',       icon: <FaMoneyBillWave />,     text: 'Contas'       },

//     ...(hasRecibosAccess
//       ? [{ path: '/verificarrecibo', icon: <FaShieldAlt />, text: 'Verificar Recibo' }]
//       : []),

//     { path: '/configuracao-empresa', icon: <FaWhmcs />, text: 'Ajustes' },

//     ...(userFirebase?.permission === 'administrador'
//       ? [{ path: '/createuser', icon: <FaUser />, text: 'Criar Usuário' }]
//       : []),
//   ];

//   // ── Submenus com indicação da feature ──
//   const relatoriosItems = [
//     {
//       path: '/relatorios/contratos-expirando',
//       icon: <FaFileContract />,
//       text: 'Contratos a Vencer',
//     },
//     {
//       path: '/relatorios/equipamentos',
//       icon: <FaTv />,
//       text: 'Equipamentos',
//       feature: 'relatorios',
//     },
//     {
//       path: '/relatorios/whatsapp',
//       icon: <FaWhatsapp />,
//       text: 'WhatsApp',
//       feature: 'relatoriosNotificacao',
//     },
//     {
//       path: '/relatorios/email',
//       icon: <FaEnvelope />,
//       text: 'E-mail',
//       feature: 'relatoriosNotificacao',
//     },
//     {
//       path: '/relatorios/veiculacao',
//       icon: <FaFileAlt />,
//       text: 'VNNOX',
//       feature: 'relatorios',
//     },
//   ];

//   const notificacoesItems = [
//     {
//       path: '/notificacoes/whatsapp',
//       icon: <FaWhatsapp />,
//       text: 'WhatsApp',
//       feature: 'whatsapp',
//     },
//     {
//       path: '/notificacoes/email',
//       icon: <FaEnvelope />,
//       text: 'E-mail',
//       feature: 'emailNotificacao',
//     },
//   ];

//   // ── Submenu de Contratos ──
//   const contratosItems = [
//     {
//       path: '/contratos',
//       icon: <FaFileSignature />,
//       text: 'Contratos Gerados',
//     },
//     {
//       path: '/contratos/modelos',
//       icon: <FaFileAlt />,
//       text: 'Modelos de Contrato',
//     },
//   ];

//   // Bloqueia navegação e abre modal se não tiver acesso
//   const handleProtectedClick = (e, item) => {
//     if (!checkAccess(item.feature)) {
//       e.preventDefault();
//       return;
//     }
//     handleLinkClick();
//   };

//   const isCollapsedDesktop = !mobileView && desktopCollapsed;

//   return (
//     <>
//       <ModalUpgradePlano
//         show={!!blockedFeature}
//         featureKey={blockedFeature}
//         currentTier={tier}
//         onClose={closeModal}
//       />

//       <div className={sidebarClass}>
//         <div className="sidebar-header">
//           <Link to="/dashboard" className="sidebar-logo">
//             {!isCollapsedDesktop && (
//               <img src={logoVermelha} alt="Logo Maxtra Mídia" className="img-logo" />
//             )}
//           </Link>
//           <button className="sidebar-toggle" onClick={handleToggle}>
//             {isCollapsedDesktop ? <FaBars /> : <FaTimes />}
//           </button>
//         </div>

//         <ul className="sidebar-menu">
//           {menuItems.map((item) => (
//             <li key={item.path} className="sidebar-menu-item">
//               <Link
//                 to={item.path}
//                 className={`sidebar-menu-link ${location.pathname === item.path ? 'active' : ''}`}
//                 onClick={handleLinkClick}
//               >
//                 <span className="sidebar-menu-icon">{item.icon}</span>
//                 <span className="sidebar-menu-text">{item.text}</span>
//               </Link>
//             </li>
//           ))}

//           {/* ─── Contratos ─── */}
//           <li className="sidebar-menu-item">
//             <button
//               className={`sidebar-menu-link sidebar-accordion-toggle ${isContratosActive ? 'active' : ''}`}
//               onClick={() => !isCollapsedDesktop && setContratosOpen(prev => !prev)}
//               title={isCollapsedDesktop ? 'Contratos' : ''}
//             >
//               <span className="sidebar-menu-icon"><FaFileContract /></span>
//               <span className="sidebar-menu-text">Contratos</span>
//               {!isCollapsedDesktop && (
//                 <span className="sidebar-accordion-arrow">
//                   {contratosOpen ? <FaChevronUp /> : <FaChevronDown />}
//                 </span>
//               )}
//             </button>

//             {contratosOpen && !isCollapsedDesktop && (
//               <ul className="sidebar-submenu">
//                 {contratosItems.map((item) => (
//                   <li key={item.path}>
//                     <Link
//                       to={item.path}
//                       className={`sidebar-menu-link sidebar-submenu-link ${
//                         location.pathname === item.path ? 'active' : ''
//                       }`}
//                       onClick={handleLinkClick}
//                     >
//                       <span className="sidebar-menu-icon">{item.icon}</span>
//                       <span className="sidebar-menu-text">{item.text}</span>
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </li>

//           {/* ─── Relatórios ─── */}
//           <li className="sidebar-menu-item">
//             <button
//               className={`sidebar-menu-link sidebar-accordion-toggle ${isRelatoriosActive ? 'active' : ''}`}
//               onClick={() => !isCollapsedDesktop && setRelatoriosOpen(prev => !prev)}
//               title={isCollapsedDesktop ? 'Relatórios' : ''}
//             >
//               <span className="sidebar-menu-icon"><FaChartPie /></span>
//               <span className="sidebar-menu-text d-flex align-items-center gap-2">
//                 Relatórios
//                 {!hasRelatoriosAccess && (
//                   <FaLock size={10} style={{ color: '#f8961e', opacity: 0.85 }} />
//                 )}
//               </span>
//               {!isCollapsedDesktop && (
//                 <span className="sidebar-accordion-arrow">
//                   {relatoriosOpen ? <FaChevronUp /> : <FaChevronDown />}
//                 </span>
//               )}
//             </button>

//             {relatoriosOpen && !isCollapsedDesktop && (
//               <ul className="sidebar-submenu">
//                 {relatoriosItems.map((item) => {
//                   const locked = item.feature ? !isAllowed(item.feature) : false;
//                   return (
//                     <li key={item.path}>
//                       <Link
//                         to={item.path}
//                         className={`sidebar-menu-link sidebar-submenu-link ${
//                           location.pathname === item.path ? 'active' : ''
//                         }`}
//                         onClick={(e) => handleProtectedClick(e, item)}
//                         style={locked ? { opacity: 0.65 } : undefined}
//                         title={locked ? 'Disponível em planos superiores' : ''}
//                       >
//                         <span className="sidebar-menu-icon">{item.icon}</span>
//                         <span className="sidebar-menu-text d-flex align-items-center justify-content-between flex-grow-1">
//                           {item.text}
//                           {locked && (
//                             <FaLock size={10} style={{ color: '#f8961e', marginLeft: 6 }} />
//                           )}
//                         </span>
//                       </Link>
//                     </li>
//                   );
//                 })}
//               </ul>
//             )}
//           </li>

//           {/* ─── Notificações ─── */}
//           <li className="sidebar-menu-item">
//             <button
//               className={`sidebar-menu-link sidebar-accordion-toggle ${isNotificacoesActive ? 'active' : ''}`}
//               onClick={() => !isCollapsedDesktop && setNotificacoesOpen(prev => !prev)}
//               title={isCollapsedDesktop ? 'Notificações' : ''}
//             >
//               <span className="sidebar-menu-icon"><FaBell /></span>
//               <span className="sidebar-menu-text d-flex align-items-center gap-2">
//                 Notificações
//                 {!hasNotificacoesAccess && (
//                   <FaLock size={10} style={{ color: '#f8961e', opacity: 0.85 }} />
//                 )}
//               </span>
//               {!isCollapsedDesktop && (
//                 <span className="sidebar-accordion-arrow">
//                   {notificacoesOpen ? <FaChevronUp /> : <FaChevronDown />}
//                 </span>
//               )}
//             </button>

//             {notificacoesOpen && !isCollapsedDesktop && (
//               <ul className="sidebar-submenu">
//                 {notificacoesItems.map((item) => {
//                   const locked = !isAllowed(item.feature);
//                   return (
//                     <li key={item.path}>
//                       <Link
//                         to={item.path}
//                         className={`sidebar-menu-link sidebar-submenu-link ${
//                           location.pathname === item.path ? 'active' : ''
//                         }`}
//                         onClick={(e) => handleProtectedClick(e, item)}
//                         style={locked ? { opacity: 0.65 } : undefined}
//                         title={locked ? 'Disponível no plano Empresarial' : ''}
//                       >
//                         <span className="sidebar-menu-icon">{item.icon}</span>
//                         <span className="sidebar-menu-text d-flex align-items-center justify-content-between flex-grow-1">
//                           {item.text}
//                           {locked && (
//                             <FaLock size={10} style={{ color: '#f8961e', marginLeft: 6 }} />
//                           )}
//                         </span>
//                       </Link>
//                     </li>
//                   );
//                 })}
//               </ul>
//             )}
//           </li>

//           {/* ─── Superadmin ─── */}
//           {user?.role === 'SUPERADMIN' && (
//             <li className="sidebar-menu-item">
//               <button
//                 className={`sidebar-menu-link sidebar-accordion-toggle ${isSuperActive ? 'active' : ''}`}
//                 onClick={() => !isCollapsedDesktop && setSuperAdminOpen(prev => !prev)}
//                 title={isCollapsedDesktop ? 'Superadmin' : ''}
//               >
//                 <span className="sidebar-menu-icon"><FaUserShield /></span>
//                 <span className="sidebar-menu-text">Superadmin</span>
//                 {!isCollapsedDesktop && (
//                   <span className="sidebar-accordion-arrow">
//                     {superAdminOpen ? <FaChevronUp /> : <FaChevronDown />}
//                   </span>
//                 )}
//               </button>

//               {superAdminOpen && !isCollapsedDesktop && (
//                 <ul className="sidebar-submenu">
//                   <li>
//                     <Link to="/super/empresas"
//                       className={`sidebar-menu-link sidebar-submenu-link ${location.pathname === '/super/empresas' ? 'active' : ''}`}
//                       onClick={handleLinkClick}>
//                       <span className="sidebar-menu-icon"><FaUserShield /></span>
//                       <span className="sidebar-menu-text">Empresas</span>
//                     </Link>
//                   </li>
//                   <li>
//                     <Link to="/super/dashboard"
//                       className={`sidebar-menu-link sidebar-submenu-link ${location.pathname === '/super/dashboard' ? 'active' : ''}`}
//                       onClick={handleLinkClick}>
//                       <span className="sidebar-menu-icon"><FaChartBar /></span>
//                       <span className="sidebar-menu-text">Dashboard Superadmin</span>
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>
//           )}
//         </ul>

//         {/* 🆕 Botão Instalar App */}
//         {canInstall && (
//           <div className="sidebar-install-wrapper">
//             <button
//               className="sidebar-install-btn"
//               onClick={promptInstall}
//               title="Instalar aplicativo"
//             >
//               <span className="sidebar-menu-icon"><FaDownload /></span>
//               {!isCollapsedDesktop && (
//                 <span className="sidebar-menu-text">Instalar App</span>
//               )}
//             </button>
//           </div>
//         )}

//         {!isCollapsedDesktop && user && (
//           <div style={{ padding: '16px', color: '#fff', fontSize: '14px' }}>
//             <strong>{user.name}</strong>
//             <div>{user.role === 'SUPERADMIN' && '(superadmin)'}</div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Sidebar;

// src/components/layout/Sidebar.jsx
import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaTachometerAlt, FaUsers, FaFileInvoiceDollar,
  FaMoneyBillWave, FaBars, FaTimes,
  FaClipboardList, FaUser, FaDesktop, FaWhmcs,
  FaBell, FaWhatsapp, FaEnvelope, FaChevronDown, FaChevronUp, FaChartBar,
  FaUserShield, FaShieldAlt, FaChartPie, FaFileAlt, FaTv, FaLock,
  FaFileContract, FaFileSignature, FaDownload
} from 'react-icons/fa';
import '../../responsive.css';
import logoVermelha from '../../assets/logo-vermelha.png';
import { AuthContext } from '../../contexts/AuthContext';
import { useFeatureGate } from '../../hooks/useFeatureGate';
import { usePWAInstall } from '../../hooks/usePWAInstall';
import ModalUpgradePlano from '../ModalUpgradePlano';

const MOBILE_BREAKPOINT = 992;
const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

const Sidebar = ({ collapsed, toggleSidebar }) => {
  const location = useLocation();
  // 🆕 companyLogo vem do contexto
  const { userFirebase, user, companyLogo } = useContext(AuthContext);

  const {
    tier,
    blockedFeature,
    checkAccess,
    closeModal,
    isAllowed,
  } = useFeatureGate();

  const { canInstall, promptInstall } = usePWAInstall();

  const [mobileView, setMobileView]             = useState(() => isMobile());
  const [desktopCollapsed, setDesktopCollapsed] = useState(false);
  const [notificacoesOpen, setNotificacoesOpen] = useState(false);
  const [relatoriosOpen,   setRelatoriosOpen]   = useState(false);
  const [superAdminOpen,   setSuperAdminOpen]   = useState(false);
  const [contratosOpen,    setContratosOpen]    = useState(false);

  // ── Acessos centralizados ──
  const hasRecibosAccess     = isAllowed('boleto');
  const hasRelatoriosAccess  =
    isAllowed('relatorios') || isAllowed('relatoriosNotificacao');
  const hasNotificacoesAccess =
    isAllowed('whatsapp') || isAllowed('emailNotificacao');

  const notificacoesRoutes = ['/notificacoes/whatsapp', '/notificacoes/email'];
  const relatoriosRoutes = [
    '/relatorios/equipamentos', '/relatorios/veiculacao',
    '/relatorios/whatsapp', '/relatorios/email', '/relatorios/contratos-expirando'
  ];
  const superAdminRoutes = ['/superadmin/empresas', '/superadmin/dashboard'];
  const contratosRoutes  = ['/contratos', '/contratos/modelos'];

  const isNotificacoesActive = notificacoesRoutes.includes(location.pathname);
  const isRelatoriosActive   = relatoriosRoutes.includes(location.pathname);
  const isSuperActive        = superAdminRoutes.includes(location.pathname);
  const isContratosActive    = contratosRoutes.includes(location.pathname);

  useEffect(() => { if (isNotificacoesActive) setNotificacoesOpen(true); }, [isNotificacoesActive]);
  useEffect(() => { if (isRelatoriosActive)   setRelatoriosOpen(true);   }, [isRelatoriosActive]);
  useEffect(() => { if (isSuperActive)        setSuperAdminOpen(true);   }, [isSuperActive]);
  useEffect(() => { if (isContratosActive)    setContratosOpen(true);    }, [isContratosActive]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = isMobile();
      setMobileView(mobile);
      if (!mobile) setDesktopCollapsed(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (desktopCollapsed) {
      setNotificacoesOpen(false);
      setRelatoriosOpen(false);
      setSuperAdminOpen(false);
      setContratosOpen(false);
    }
  }, [desktopCollapsed]);

  const handleLinkClick = useCallback(() => {
    if (mobileView) toggleSidebar();
  }, [mobileView, toggleSidebar]);

  const handleToggle = () => {
    if (mobileView) toggleSidebar();
    else setDesktopCollapsed(prev => !prev);
  };

  const sidebarClass = [
    'sidebar',
    !mobileView && desktopCollapsed ? 'collapsed' : '',
    mobileView && !collapsed ? 'show' : '',
  ].filter(Boolean).join(' ');

  const menuItems = [
    { path: '/dashboard',    icon: <FaTachometerAlt />,     text: 'Dashboard'    },
    { path: '/clientes',     icon: <FaUsers />,             text: 'Clientes'     },
    { path: '/equipamentos', icon: <FaDesktop />,           text: 'Equipamentos' },
    { path: '/planos',       icon: <FaClipboardList />,     text: 'Planos'       },
    { path: '/pedidos',      icon: <FaFileInvoiceDollar />, text: 'Pedidos'      },
    { path: '/contas',       icon: <FaMoneyBillWave />,     text: 'Contas'       },

    ...(hasRecibosAccess
      ? [{ path: '/verificarrecibo', icon: <FaShieldAlt />, text: 'Verificar Recibo' }]
      : []),

    { path: '/configuracao-empresa', icon: <FaWhmcs />, text: 'Ajustes' },

    ...(userFirebase?.permission === 'administrador'
      ? [{ path: '/createuser', icon: <FaUser />, text: 'Criar Usuário' }]
      : []),
  ];

  const relatoriosItems = [
    {
      path: '/relatorios/contratos-expirando',
      icon: <FaFileContract />,
      text: 'Contratos a Vencer',
    },
    {
      path: '/relatorios/equipamentos',
      icon: <FaTv />,
      text: 'Equipamentos',
      feature: 'relatorios',
    },
    {
      path: '/relatorios/whatsapp',
      icon: <FaWhatsapp />,
      text: 'WhatsApp',
      feature: 'relatoriosNotificacao',
    },
    {
      path: '/relatorios/email',
      icon: <FaEnvelope />,
      text: 'E-mail',
      feature: 'relatoriosNotificacao',
    },
    {
      path: '/relatorios/veiculacao',
      icon: <FaFileAlt />,
      text: 'VNNOX',
      feature: 'relatorios',
    },
  ];

  const notificacoesItems = [
    {
      path: '/notificacoes/whatsapp',
      icon: <FaWhatsapp />,
      text: 'WhatsApp',
      feature: 'whatsapp',
    },
    {
      path: '/notificacoes/email',
      icon: <FaEnvelope />,
      text: 'E-mail',
      feature: 'emailNotificacao',
    },
  ];

  const contratosItems = [
    {
      path: '/contratos',
      icon: <FaFileSignature />,
      text: 'Contratos Gerados',
    },
    {
      path: '/contratos/modelos',
      icon: <FaFileAlt />,
      text: 'Modelos de Contrato',
    },
  ];

  const handleProtectedClick = (e, item) => {
    if (!checkAccess(item.feature)) {
      e.preventDefault();
      return;
    }
    handleLinkClick();
  };

  const isCollapsedDesktop = !mobileView && desktopCollapsed;

  // 🆕 Logo final com fallback
  const logoFinal = companyLogo || logoVermelha;

  return (
    <>
      <ModalUpgradePlano
        show={!!blockedFeature}
        featureKey={blockedFeature}
        currentTier={tier}
        onClose={closeModal}
      />

      <div className={sidebarClass}>
        <div className="sidebar-header">
          <Link to="/dashboard" className="sidebar-logo">
            {!isCollapsedDesktop && (
              <img
                src={logoFinal}
                alt="Logo da empresa"
                className="img-logo"
                onError={(e) => { e.currentTarget.src = logoVermelha; }}
              />
            )}
          </Link>
          <button className="sidebar-toggle" onClick={handleToggle}>
            {isCollapsedDesktop ? <FaBars /> : <FaTimes />}
          </button>
        </div>

        <ul className="sidebar-menu">
          {menuItems.map((item) => (
            <li key={item.path} className="sidebar-menu-item">
              <Link
                to={item.path}
                className={`sidebar-menu-link ${location.pathname === item.path ? 'active' : ''}`}
                onClick={handleLinkClick}
              >
                <span className="sidebar-menu-icon">{item.icon}</span>
                <span className="sidebar-menu-text">{item.text}</span>
              </Link>
            </li>
          ))}

          {/* ─── Contratos ─── */}
          <li className="sidebar-menu-item">
            <button
              className={`sidebar-menu-link sidebar-accordion-toggle ${isContratosActive ? 'active' : ''}`}
              onClick={() => !isCollapsedDesktop && setContratosOpen(prev => !prev)}
              title={isCollapsedDesktop ? 'Contratos' : ''}
            >
              <span className="sidebar-menu-icon"><FaFileContract /></span>
              <span className="sidebar-menu-text">Contratos</span>
              {!isCollapsedDesktop && (
                <span className="sidebar-accordion-arrow">
                  {contratosOpen ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              )}
            </button>

            {contratosOpen && !isCollapsedDesktop && (
              <ul className="sidebar-submenu">
                {contratosItems.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`sidebar-menu-link sidebar-submenu-link ${
                        location.pathname === item.path ? 'active' : ''
                      }`}
                      onClick={handleLinkClick}
                    >
                      <span className="sidebar-menu-icon">{item.icon}</span>
                      <span className="sidebar-menu-text">{item.text}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>

          {/* ─── Relatórios ─── */}
          <li className="sidebar-menu-item">
            <button
              className={`sidebar-menu-link sidebar-accordion-toggle ${isRelatoriosActive ? 'active' : ''}`}
              onClick={() => !isCollapsedDesktop && setRelatoriosOpen(prev => !prev)}
              title={isCollapsedDesktop ? 'Relatórios' : ''}
            >
              <span className="sidebar-menu-icon"><FaChartPie /></span>
              <span className="sidebar-menu-text d-flex align-items-center gap-2">
                Relatórios
                {!hasRelatoriosAccess && (
                  <FaLock size={10} style={{ color: '#f8961e', opacity: 0.85 }} />
                )}
              </span>
              {!isCollapsedDesktop && (
                <span className="sidebar-accordion-arrow">
                  {relatoriosOpen ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              )}
            </button>

            {relatoriosOpen && !isCollapsedDesktop && (
              <ul className="sidebar-submenu">
                {relatoriosItems.map((item) => {
                  const locked = item.feature ? !isAllowed(item.feature) : false;
                  return (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        className={`sidebar-menu-link sidebar-submenu-link ${
                          location.pathname === item.path ? 'active' : ''
                        }`}
                        onClick={(e) => handleProtectedClick(e, item)}
                        style={locked ? { opacity: 0.65 } : undefined}
                        title={locked ? 'Disponível em planos superiores' : ''}
                      >
                        <span className="sidebar-menu-icon">{item.icon}</span>
                        <span className="sidebar-menu-text d-flex align-items-center justify-content-between flex-grow-1">
                          {item.text}
                          {locked && (
                            <FaLock size={10} style={{ color: '#f8961e', marginLeft: 6 }} />
                          )}
                        </span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>

          {/* ─── Notificações ─── */}
          <li className="sidebar-menu-item">
            <button
              className={`sidebar-menu-link sidebar-accordion-toggle ${isNotificacoesActive ? 'active' : ''}`}
              onClick={() => !isCollapsedDesktop && setNotificacoesOpen(prev => !prev)}
              title={isCollapsedDesktop ? 'Notificações' : ''}
            >
              <span className="sidebar-menu-icon"><FaBell /></span>
              <span className="sidebar-menu-text d-flex align-items-center gap-2">
                Notificações
                {!hasNotificacoesAccess && (
                  <FaLock size={10} style={{ color: '#f8961e', opacity: 0.85 }} />
                )}
              </span>
              {!isCollapsedDesktop && (
                <span className="sidebar-accordion-arrow">
                  {notificacoesOpen ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              )}
            </button>

            {notificacoesOpen && !isCollapsedDesktop && (
              <ul className="sidebar-submenu">
                {notificacoesItems.map((item) => {
                  const locked = !isAllowed(item.feature);
                  return (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        className={`sidebar-menu-link sidebar-submenu-link ${
                          location.pathname === item.path ? 'active' : ''
                        }`}
                        onClick={(e) => handleProtectedClick(e, item)}
                        style={locked ? { opacity: 0.65 } : undefined}
                        title={locked ? 'Disponível no plano Empresarial' : ''}
                      >
                        <span className="sidebar-menu-icon">{item.icon}</span>
                        <span className="sidebar-menu-text d-flex align-items-center justify-content-between flex-grow-1">
                          {item.text}
                          {locked && (
                            <FaLock size={10} style={{ color: '#f8961e', marginLeft: 6 }} />
                          )}
                        </span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>

          {/* ─── Superadmin ─── */}
          {user?.role === 'SUPERADMIN' && (
            <li className="sidebar-menu-item">
              <button
                className={`sidebar-menu-link sidebar-accordion-toggle ${isSuperActive ? 'active' : ''}`}
                onClick={() => !isCollapsedDesktop && setSuperAdminOpen(prev => !prev)}
                title={isCollapsedDesktop ? 'Superadmin' : ''}
              >
                <span className="sidebar-menu-icon"><FaUserShield /></span>
                <span className="sidebar-menu-text">Superadmin</span>
                {!isCollapsedDesktop && (
                  <span className="sidebar-accordion-arrow">
                    {superAdminOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                )}
              </button>

              {superAdminOpen && !isCollapsedDesktop && (
                <ul className="sidebar-submenu">
                  <li>
                    <Link to="/super/empresas"
                      className={`sidebar-menu-link sidebar-submenu-link ${location.pathname === '/super/empresas' ? 'active' : ''}`}
                      onClick={handleLinkClick}>
                      <span className="sidebar-menu-icon"><FaUserShield /></span>
                      <span className="sidebar-menu-text">Empresas</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/super/dashboard"
                      className={`sidebar-menu-link sidebar-submenu-link ${location.pathname === '/super/dashboard' ? 'active' : ''}`}
                      onClick={handleLinkClick}>
                      <span className="sidebar-menu-icon"><FaChartBar /></span>
                      <span className="sidebar-menu-text">Dashboard Superadmin</span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )}
        </ul>

        {/* 🆕 Botão Instalar App */}
        {canInstall && (
          <div className="sidebar-install-wrapper">
            <button
              className="sidebar-install-btn"
              onClick={promptInstall}
              title="Instalar aplicativo"
            >
              <span className="sidebar-menu-icon"><FaDownload /></span>
              {!isCollapsedDesktop && (
                <span className="sidebar-menu-text">Instalar App</span>
              )}
            </button>
          </div>
        )}

        {!isCollapsedDesktop && user && (
          <div style={{ padding: '16px', color: '#fff', fontSize: '14px' }}>
            <strong>{user.name}</strong>
            <div>{user.role === 'SUPERADMIN' && '(superadmin)'}</div>
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;
